import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import { search_icon } from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
// import DatePicker from "react-multi-date-picker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import { useLazyPropertiesBlockedDropQuery, useLazyTotalLocationsListQuery, usePropertyBlockDateListMutation, usePropertyBlockListMutation, usePropertyUnblockMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import moment from "moment";

const PropertyUnBlock = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [list, setList] = useState([]);
  const [status, setStatus] = useState();
  const [selectedDates, setSelectedDates] = useState([]);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [selectedCityId, setSelectedCityId] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState('');
  const [loading, setLoading] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [category, setCategory] = useState([])
  const [fromdate, setFromDate] = useState(moment())
  const [toDate, setToDate] = useState(moment())
  const [search, setSearch] = useState('')
  const [type, setType] = useState('')
  const [count, setCount] = useState();
  const [cities, setCities] = useState([]);
  const [properties, setProperties] = useState([]);
  const [blockedDates, setBlockedDates] = useState([]);
  const [id, setId] = useState();
  const [propertyId, setPropertyId] = useState();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

  const calenderRef = useRef();

  const [show, setShow] = useState(false);


  const [propertyBlockApi] = usePropertyBlockListMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [getPropertyApi] = useLazyPropertiesBlockedDropQuery();
  const [blockedPropertyDatesApi] = usePropertyBlockDateListMutation();
  const [unBlockPropertyApi] = usePropertyUnblockMutation();



  const propertyBlockList = (
    fromdate,
    toDate,
    selectedPropertyId,
    // selectedCityId,
    search,
    pageno,

  ) => {
    const formdata = new FormData();
    formdata.append("block_type", 1);
    if (fromdate && toDate) {
      formdata.append('from_date', moment(fromdate).format('YYYY-MM-DD'))
      formdata.append('to_date', moment(toDate).format('YYYY-MM-DD'))
    }
    if (selectedPropertyId) {
      formdata.append('property', selectedPropertyId)
    }
    if (selectedCityId) {
      formdata.append('city', selectedCityId)
    }
    if (search) {
      formdata.append('search', search)
    }

    formdata.append('page', pageno)
    formdata.append('per_page', 10)

    setFromDate(fromdate);
    setToDate(toDate);
    setSelectedPropertyId(selectedPropertyId);
    setSelectedCityId(selectedCityId);
    setSearch(search);

    propertyBlockApi(formdata)
      .unwrap()
      .then((res) => {
        // res?.data?.map((item) => {
        //   setId(item?.id);
        //   setPropertyId(item?.property_id);
        // });
        let temp = []
        res?.data?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        setPagecount(res?.pagination)
        setCount(res?.pagination?.total)
      })
      .catch((err) => {
        console.log(err);
        // toast.error('Failed to fetch property details');
      });
  };


  const getLocations = () => {
    getCityApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        let temp = res?.data?.filter((item) => item?.type == 3);
        setCities(temp);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  const getProperty = () => {
    getPropertyApi()
      .unwrap()
      .then((res) => {
        const formattedProperties = res?.data
        // const formattedProperties = res?.data?.map((propertyName, index) => ({
        //     value: propertyName?.name,
        //     label: propertyName?.name,
        //     name: propertyName?.name,
        // })) || [];
        setProperties(formattedProperties);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // console.log("ids",propertyId,id);



  const getBlockedDates = (ids) => {

    const formdata = new FormData();
    formdata.append("property_id", ids?.property_id);
    formdata.append("block_id", ids?.id);
    blockedPropertyDatesApi(formdata)
      .unwrap()
      .then((res) => {
        console.log(res);
        handleShow();
        setBlockedDates(res?.data);

      })
      .catch((err) => {
        console.error(err);
      });
  };

  const UnBlockedDates = (ids) => {
    const formdata = new FormData();
    formdata.append("property_id", propertyId);
    formdata.append("block_id", id);


    let count = 1;

    if (selectedDates?.length >= 1) {
      selectedDates.forEach((item, index) => {
        formdata.append(`ids[${index}]`, item);
      })
    } else {
      count = count + 1
    }

    if (count == 1) {

      unBlockPropertyApi(formdata)
        .unwrap()
        .then((res) => {
          console.log(res);
          if (res?.status == "success") {
            toast.success(res?.message);
            handleClose();
            propertyBlockList(fromdate,
              toDate,
              selectedPropertyId,
              // selectedCityId,
              search,
              pageno,);
          }

        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      toast.error("UnBlocked Rooms field must be at least 1");
    }
  };





  const getDetails = (item) => {
    handleShow();

    // setTimeout(() => {
    //   calenderRef.current.click();
    // }, 500);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "From Date",
        accessor: "from_date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "To Date",
        accessor: "to_date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row?.original?.property } })}>{row?.original?.property?.name}</p></div>
        },
      },
      {
        Header: "Type",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row?.original?.property?.property_type == 1 ? "Rooms" : row?.original?.property?.property_type == 2 ? "Individual" : ""}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "property",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.property?.owner?.id } })}>{value?.owner?.name}</p></div>
        },
      },
      {
        Header: "Blocked By",
        accessor: "property_blockable",
        Cell: ({ value, row }) => {
          return <p>{value?.username ? value?.username : value?.name}</p>;
        },
      },
      {
        Header: "Blocked On",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "Unblock",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-EDIT-BLOCKED') &&
                  <button
                    className="cust-btn approve-btn"
                    onClick={() => { getBlockedDates(row?.original); setId(row?.original?.id); setPropertyId(row?.original?.property_id) }}
                  >
                    <p className="mb-0">Unblock</p>
                  </button>}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );



  useEffect(() => {
    // getLocations()
    getProperty()
    propertyBlockList(
      fromdate,
      toDate,
      selectedPropertyId,
      // selectedCityId,
      search,
      pageno,

    );
  }, [pageno]);



  const selectedDatesId = (id) => {
    let temp = [...selectedDates];
    if (temp.includes(id)) {
      temp = temp.filter(item => item != id);
    } else {
      temp.push(id);
    }
    setSelectedDates(temp);

  }

  return (
    <div className="dashRightView home_section">
      <Modal show={show} onHide={handleClose}    >
        <div className="p-4 " style={{ maxHeight: "80vh", overflow: "scroll" }}
        >
          <div className="p-1">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-22 sec ">
                Property Block - Unblock
              </h2>
              <button
                className="border-0 bg-transparent"
                onClick={() => handleClose()}
              >
                <CloseIcon />
              </button>
            </div>
            <div className=" mt-5 w-100" >
              {blockedDates?.map((item, ind) => {
                return (
                  <div className="d-flex ac-jb mb-4 w-100 pe-2" style={{ borderBottom: "2px solid #D9D9D9", }} key={ind}>
                    <p className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 ">
                      Date : {moment(item?.for_date).format("DD-MM-YYYY")}
                    </p>
                    <input onClick={() => selectedDatesId(item?.id)} checked={selectedDates?.includes(item?.id)} type="checkbox" className="pe-3" />
                  </div>
                )
              })}
            </div>
            <div className="col-md-12 d-flex ac-jc mt-3">
              <button
                className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                onClick={() => UnBlockedDates()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
        Block - Property Block
      </h2>
      <div className="d-flex ac-jb mt-4">
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          From Date
        </label>
        <div className="w-15">
          <DatePicker
            selected={fromdate}
            onChange={(e) => {
              propertyBlockList(
                e,
                toDate,
                selectedPropertyId,
                // selectedCityId,
                search,
                1,
              );
            }
            }
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="From Date"
            type="date"
          />
        </div>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          To Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="To Date"
            selected={toDate}
            onChange={(e) => propertyBlockList(
              fromdate,
              e,
              selectedPropertyId,
              // selectedCityId,
              search,
              1,
            )}
          />
        </div>
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          Property Name
        </label>
        {/* <input
                  type="text"
                  value={propertyName}
                  onChange={(e) => setPropertyName(e.target.value)}
                  className="input-pop-new ps-2 col-md-1"
                  placeholder="Property Name"
                /> */}
        <CustomSearchSelect
          options={properties}
          value={selectedPropertyId}
          onChange={(value) => {
            setSelectedPropertyId(value);
            propertyBlockList(
              fromdate,
              toDate,
              value,
              search,
              1,
            );
          }}
          placeholder="Select Property"
          width="200px"
        />
        {/* <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          City
        </label> */}
        {/* <input
                  type="text"
                  value={cityName}
                  onChange={(e) => setCityName(e.target.value)}
                  className="input-pop-new ps-2 col-md-2"
                  placeholder="City"
                /> */}
        {/* <CustomSearchSelect
          options={cities}
          value={selectedCityId}
          onChange={(value) => {
            setSelectedCityId(value);
            propertyBlockList(
              fromdate,
              toDate,
              // selectedPropertyId,
              value,
              search,
              1,
            );
          }}
          placeholder="Select City"
          width="200px"
        /> */}
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          Search
        </label>
        <div className="search-input ">
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={search}
            onChange={(e) =>
              propertyBlockList(
                fromdate,
                toDate,
                selectedPropertyId,
                // selectedCityId,
                e.target.value,
                1,
              )
            }
          />
          <img src={search_icon} className="search" />
        </div>
      </div>
      <div className="d-flex ac-js mt-3">

      </div>

      <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
    </div>
  );
};

export default PropertyUnBlock;
